export default __webpack_public_path__ + "static/media/Punto_08_Piazza_della_Repubblica_DEU_Def.033a58b3.aac";